<template>
  <div class="water-panel">
    <v-card variant="outlined" rounded="lg" class="water-pending pa-8 text-center">
      <v-icon size="48" color="primary" class="mb-4 opacity-60">mdi-draw</v-icon>
      <h3 class="text-subtitle-1 font-weight-semibold mb-2">水机策略</h3>
      <p class="text-body-2 text-medium-emphasis mb-0">待设计</p>
      <p class="text-caption text-medium-emphasis mt-2 mb-0">
        后续将在此配置冷水机组、冷冻水侧与联动策略；当前步骤仅保留占位，不参与业务下发。
      </p>
    </v-card>
  </div>
</template>

<script setup>
defineExpose({
  getDraft: () => ({
    module: 'water_chiller',
    designStatus: 'pending',
  }),
})
</script>

<style scoped lang="scss">
.water-panel {
  max-width: 720px;
}

.water-pending {
  border-style: dashed !important;
  border-color: color-mix(in srgb, var(--color-primary, #2b57ee) 22%, #e9efff) !important;
  background: #fafbff;
}
</style>
